
/**
 * @file pluginPieces.js
 * @author Geoffrey Pursell
 * @desc Plugin Pieces

*/

/**
 * @module cardboard/pluginPieces
 * @desc Plugin Pieces
 */

define('cardboard/pluginPieces',[],
function () {

	console.log("MODULE: pluginPieces");

	var exports = {

		/** the standard error condition, usable by all data sources that use
		 * our standard meta/data JSON layout.
		 * @member {Object} */
		standardErrorCondition: {
			valuePath: "meta.dataNotAvailableMessage",
			isNot: null,
			error: {
				type: "NoData",
				messagePath: "meta.dataNotAvailableMessage"
			}
		},
		/** the standard error condition, only a silent version that does not
		 * present an error message. useful for when you have two adjacent views
		 * with the same backing data, and don't want two error messages in a
		 * row.
		 * @member {Object} */
		silentStandardErrorCondition: {
			valuePath: "meta.dataNotAvailableMessage",
			isNot: null,
			error: {
				type: "NoData"
			}
		}

	};

	return exports;
});

